(function () {
    "use strict";

    angular.module("app").factory("securityIncidentsApi", SecurityIncidentsFactory);

    SecurityIncidentsFactory.$inject = [
        "apiClientFactory", "webApiServices", "notificationService",
    ];
    function SecurityIncidentsFactory(
        apiClientFactory, webApiServices, notificationService,
    ) {

        const routePrefix = "api/security-incidents/";

        return {
            Search: apiClientFactory.post(`${routePrefix}search`),
            Create: apiClientFactory.post(`${routePrefix}`),
            Get: apiClientFactory.get(`${routePrefix}`),
            AddStatus: (securityIncidentId) => apiClientFactory.post(`${routePrefix}${securityIncidentId}/status`),
            GetComments: (securityIncidentId) => (successCallback) => apiClientFactory.get(`${routePrefix}${securityIncidentId}/comments`)(null, (response) => successCallback(response.data)),
            AddComment: (securityIncidentId) => (comment, successCallback) => {
                webApiServices.SaveSecurityIncidentComment(
                    { OwnerId: securityIncidentId, Message: comment.message, NotifyUserRoles: comment.forRole ? [comment.forRole] : [] },
                    successCallback,
                    (err) => DoShowError(notificationService, err));
            },
            CreateScreenings: (securityIncidentId) => apiClientFactory.post(`${routePrefix}${securityIncidentId}/screenings`),
        };
    }
})();
